import powerBulbImage from "../../Assets/Images/su-power-bulb.png";
import Card from "./card";
import HeadlineBlock from "./headline-block";
import PrimaryButton from "./primary-button";
import Tiles, { TILE_ICONS } from "./tiles";
import { UTILITY_STEPS, formatMoney } from "./utilities-config";

export default function PowerSignUp({ cashBack, onContinue, onLater }) {
  return (
    <Card
      steps={UTILITY_STEPS}
      activeStep={0}
      progress={40}
      footer={
        <>
          <PrimaryButton onClick={onContinue}>Continue</PrimaryButton>
          <button className="su-link" type="button" onClick={onLater}>
            Maybe later
          </button>
        </>
      }
    >
      <div className="su-illustration su-illustration--power" aria-hidden="true">
        <img src={powerBulbImage} alt="" />
      </div>
      <HeadlineBlock lines="One click power setup." accent={`${formatMoney(cashBack)} Cash Back.`} sub="Your lights work the day you walk in." />
      <Tiles
        items={[
          { icon: TILE_ICONS.bolt, label: "Quick setup" },
          { icon: TILE_ICONS.leaf, label: "Green energy" },
          { icon: TILE_ICONS.houseCheck, label: "Nothing to install" },
        ]}
      />
    </Card>
  );
}
